export default function isHubspotEnabled() {
  return Boolean(process.env.HUBSPOT_ENABLED);
}
